import React from 'react';
import ReactDOM from 'react-dom/client'; // Updated to use the new API for React 18
import './index.css';
import App from './App';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

async function initializeApplication() {
  try {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();

    // Use createRoot for React 18
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Error during MSAL initialization or handleRedirectPromise:', error);
    // Optionally, you can render an error component or page here
  }
}

initializeApplication();

// Disable hot module replacement to prevent network spam
if (module.hot) {
  module.hot.decline();
}
